module.exports = __webpack_public_path__ + "static/media/Capture.b12c4045.PNG";